import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CartState {
  /** skuCode -> quantity. */
  items: Record<string, number>
  add: (skuCode: string) => void
  remove: (skuCode: string) => void
  setQty: (skuCode: string, qty: number) => void
  clear: () => void
}

export const useCartStore = create<CartState>()(
  persist(
    (set) => ({
      items: {},
      add: (skuCode) => set((s) => ({ items: { ...s.items, [skuCode]: (s.items[skuCode] ?? 0) + 1 } })),
      remove: (skuCode) =>
        set((s) => {
          const items = { ...s.items }
          delete items[skuCode]
          return { items }
        }),
      setQty: (skuCode, qty) =>
        set((s) => {
          if (qty <= 0) {
            const items = { ...s.items }
            delete items[skuCode]
            return { items }
          }
          return { items: { ...s.items, [skuCode]: qty } }
        }),
      clear: () => set({ items: {} }),
    }),
    { name: 'wargame-store-cart' },
  ),
)

export function cartCount(items: Record<string, number>): number {
  return Object.values(items).reduce((sum, n) => sum + n, 0)
}
